import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useScreenWidth } from "Root/quiz/hooks/useScrollHook";
import { useState } from "react";
import CheckoutIngredientsCarousel from "../CheckoutResultsIngredientsCarousel";
import { useSelector } from "react-redux";
import getAminoAcidProfile from "Root/profile/components/common/ProductDetailsDrawer/helpers/getAminoAcidProfile";
import styles from "./styles.module.scss";
import SmallFont from "Root/profile/components/common/SmallFont";
import RegFont from "Root/profile/components/common/RegFont";
import GutHealth from "Icons/health_goals/gut_health.svg";
import Immunity from "Icons/health_goals/immune.svg";
import BrainHealth from "Icons/health_goals/brain_health.svg";
import Collagen1 from "./images/Collagen1-min.jpg";
import Collagen2 from "./images/Collagen2-min.jpg";
import Creatine1 from "./images/Creatine1-min.jpg";
import Creatine2 from "./images/Creatine2-min.jpg";
import Fiber1 from "./images/Fiber1-min.jpg";
import Fiber2 from "./images/Fiber2-min.jpg";
import Hydration1 from "./images/Hydration1-min.jpg";
import Hydration2 from "./images/Hydration2-min.jpg";
import Protein1 from "./images/Protein1-min.jpg";
import Protein2 from "./images/Protein2-min.jpg";
import Greens1 from "./images/Greens1.png";
import Greens2 from "./images/Greens2.png";
import PW1 from "./images/PW1-min.jpg";
import PW2 from "./images/PW2-min.jpg";
import GreensNutritionLemonGinger from "./images/grnfl28-nutrition-facts.png";
import GreensNutritionTropicalPineapple from "./images/grnfp28-nutrition-facts.png";
import { MenuItem, Select } from "@mui/material";
const minus = (_jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M16 8L0 8", stroke: "#333333", strokeWidth: "2" }) }));
const plus = (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { d: "M8 0V16", stroke: "#333333", strokeWidth: "2" }), _jsx("path", { d: "M16 8L0 8", stroke: "#333333", strokeWidth: "2" })] }));
const accordions = [
    {
        key: "nutrition",
        title: "Nutrition Facts",
        content: (item, _, productData) => {
            const isGreens = item.title.toLowerCase().includes("greens");
            const [selectedNutrition, setSelectedNutrition] = useState("tropicalpineapple");
            if (isGreens) {
                const nutrition = selectedNutrition === "tropicalpineapple"
                    ? GreensNutritionTropicalPineapple
                    : GreensNutritionLemonGinger;
                return (_jsxs("div", { className: styles.select, children: [_jsxs(Select, { value: selectedNutrition, onChange: (e) => setSelectedNutrition(e.target.value), children: [_jsx(MenuItem, { value: "tropicalpineapple", children: "Tropical Pineapple" }), _jsx(MenuItem, { value: "lemonginger", children: "Lemon Ginger" })] }), _jsx("img", { style: {
                                display: "block",
                                maxWidth: "100%",
                                margin: "0 auto",
                                maxHeight: 600,
                            }, src: nutrition })] }));
            }
            return (_jsx("img", { style: {
                    display: "block",
                    maxWidth: "100%",
                    margin: "0 auto",
                    maxHeight: 600,
                }, src: productData.nutrition_facts }));
        },
    },
    {
        key: "ingredients",
        title: "Key Ingredients",
        content: (_, ingredientInfo, __) => {
            return (_jsx(CheckoutIngredientsCarousel, { ingredients: ingredientInfo.ingredients }));
        },
    },
    {
        key: "benefits",
        title: "Key Benefits",
        content: (item, ingredientInfo, __) => {
            const isGreens = item.title.toLowerCase().includes("greens");
            if (isGreens) {
                const vals = [
                    {
                        icon: GutHealth,
                        hed: "Gut Health",
                        body: "Supports your gut microbiome and enhance nutrient absorption.",
                        ingredients: "Fiber, prebiotics, probiotics & natural occurring enzymes.",
                    },
                    {
                        icon: Immunity,
                        hed: "immunity & vitality",
                        body: "Nurture your overall health and immunity with phytonutrients from whole food ingredients including 11 organic fruits and vegetables.",
                        ingredients: "Spirulina, Wheatgrass, Chlorella, Kale",
                    },
                    {
                        icon: BrainHealth,
                        hed: "mental strength & focus",
                        body: "Enhance cognitive function and mental strength with a blend of powerful adaptogens",
                        ingredients: "L-Theanine, Ginseng and more",
                    },
                ];
                return (_jsx("div", { children: vals.map((val, index) => {
                        return (_jsxs("div", { className: styles.benefitContainer, children: [_jsx("img", { src: val.icon, alt: "", className: styles.benefitIcon }), _jsxs("div", { className: styles.benefitCopy, children: [_jsx("div", { className: styles.benefitHed, children: val.hed }), _jsx("div", { className: styles.benefitBody, children: val.body }), _jsx("div", { className: styles.benefitFooter, children: val.ingredients })] })] }, val.body));
                    }) }));
            }
            return (_jsx("div", { className: styles.benefits_list, children: ingredientInfo?.key_benefits?.map((item, index) => (_jsxs("div", { className: styles.benefit_item, children: [_jsx("span", { className: styles.checkmark, children: _jsx("svg", { width: "15", height: "15", viewBox: "0 0 20 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M1 7L7 13L19 1", stroke: "#333", strokeWidth: "2" }) }) }), _jsx(RegFont, { children: item })] }, item))) }));
        },
    },
    {
        key: "how_to_use",
        title: "How to Use",
        content: (item, __, productData) => {
            const isGreens = item.title.toLowerCase().includes("greens");
            const { how_to_use } = productData;
            const data = Array.isArray(how_to_use) ? how_to_use : [how_to_use];
            return (_jsxs("div", { className: styles.how_to_use, children: [data.map((item, index) => (_jsxs("div", { className: styles.how_to_use_item, children: [_jsx("span", { className: styles.badge, children: _jsx(SmallFont, { className: styles.badgeContents, fontWeight: 400, color: "#fff", children: index + 1 }) }), _jsx(RegFont, { children: item })] }, item))), isGreens && (_jsx("div", { className: styles.whenToTakeGreens, children: _jsx(RegFont, { children: "Best consumed in the morning on an empty stomach to kickstart your day." }) }))] }));
        },
    },
    {
        key: "when_to_take",
        title: "When to Take",
        content: (_, __, productData) => {
            const { when_to_take } = productData;
            return (_jsx("div", { className: styles.how_to_use, children: when_to_take?.map((item, index) => (_jsxs("div", { className: [
                        styles.how_to_use_item,
                        styles.when_to_take_item,
                    ].join(" "), children: [_jsx("img", { src: item.image, alt: "" }), _jsx(RegFont, { children: item.text })] }, item.text))) }));
        },
        hideIf: (_, __, productData) => {
            return productData?.when_to_take?.length === 0;
        },
    },
    {
        key: "amino_acid",
        title: "Amino Acid Profile",
        content: (product, _) => {
            return (_jsx("img", { src: getAminoAcidProfile(product.sku), style: {
                    display: "block",
                    maxWidth: "100%",
                    margin: "0 auto",
                    maxHeight: 600,
                }, alt: "" }));
        },
        hideIf: (cartItem, _, __) => {
            return cartItem.item_type !== "protein";
        },
    },
];
const useCheckoutResultsProductDrawer = () => {
    const isMobile = useScreenWidth() < 968;
    const productData = useSelector((state) => state.currentProduct);
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const images = {
        collagen: [Collagen1, Collagen2],
        creatine: [Creatine1, Creatine2],
        fiber: [Fiber1, Fiber2],
        hydration: [Hydration1, Hydration2],
        protein: [Protein1, Protein2],
        preworkout: [PW1, PW2],
        greens: [Greens1, Greens2],
    };
    return {
        isMobile,
        accordions,
        minus,
        plus,
        productData,
        isTooltipOpen,
        setIsTooltipOpen,
        images,
    };
};
export default useCheckoutResultsProductDrawer;
